import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    newTopupInfoResponse: {},
    showLoader: 0,
    userProfileAndTariffsObject: {},
    token: "",
    applicationName: "etopupF2G",
    cardAndRecurringInfoObject: {},
    cardBrand: "",
    cardPan: "",
    expiryDate: "",
    guid: "unknown",
    taxNumber: "unknownTaxNumber",
    customerCode: "unknownCustomerCode",
    customerName: "unknownCustomerName",
    hostName: "212.205.16.1",
    urlParamMsisdn: "",
    urlParamAmount: "",
    urlParamTransactionCode: "",
    urlParamIsReccuring: "",
    urlParamRecurringDate: "",
    urlParamRecurringAmount: "",
    activeFlow: true,
    showSuccessComponent: false,
    showErrorComponent: false,
    showWarningModal: false,
    forcePersonalDataMessage: "",
    forcePersonalDataErrorMessage: "",
    faultDescription: "",
    email: "",
    showSavedCardComponent: false,
    cardList: {},
    amount: "",
    locale: "",
    isDevMode: false,
    loginInfo: "",
    showAutoRechargeModal: false,
    showDisableAutoRechargePrompt: false,
    isUpdateReccuringAction: false,
    updateRecurringActionMsisdn: "",
    updateRecurringActionAmount: "",
    updateRecurringActionDate: "",
    updateRecurringActionTransactionCode: "",
    isDeleteReccuringAction: false,
    errorFromBank: false,
    isDataJumpSession: false,
    isDataJumpFlow: false,
  },
  getters: {
    getIsDataJumpFlow: (state) => {
      return state.isDataJumpFlow;
    },
    getIsDataJumpSession: (state) => {
      return state.isDataJumpSession;
    },
  },
  mutations: {
    setIsDataJumpFlow(state, data) {
      state.isDataJumpFlow = data;
    },
    setIsDataJumpSession(state, data) {
      state.isDataJumpSession = data;
    },
    setNewTopupInfoResponse(state, data) {
      state.newTopupInfoResponse = data;
    },
    showLoader(state) {
      state.showLoader = 1;
    },
    hideLoader(state) {
      state.showLoader = 0;
    },
    setUserProfileAndTariffs(state, data) {
      state.userProfileAndTariffsObject = data;
    },
    setToken(state, data) {
      state.token = data;
    },
    setCardAndRecurringInfo(state, data) {
      state.cardAndRecurringInfoObject = data;
      state.cardList = data.cardList;
      // if (data.cardList.length > 0){
      //   state.cardBrand = data.cardList[0].brand;
      //   state.cardPan = data.cardList[0].pan;
      //   state.expiryDate = data.cardList[0].expiryDate;
      // }
    },
    setUrlParamMsisdn(state, data) {
      state.urlParamMsisdn = data;
    },
    setUrlParamAmount(state, data) {
      state.urlParamAmount = data;
    },
    setUrlParamTransactionCode(state, data) {
      state.urlParamTransactionCode = data;
    },
    setUrlParamIsReccuring(state, data) {
      state.urlParamIsReccuring = data;
    },
    setUrlParamRecurringDate(state, data) {
      state.urlParamRecurringDate = data;
    },
    setUrlParamRecurringAmount(state, data) {
      state.urlParamRecurringAmount = data;
    },
    setActiveFlow(state, data) {
      state.activeFlow = data;
    },
    showSuccessComponent(state, data) {
      state.showSuccessComponent = data;
    },
    showErrorComponent(state, data) {
      state.showErrorComponent = data;
    },
    showWarningModal(state, data) {
      state.showWarningModal = data;
    },
    forcePersonalDataMessage(state, data) {
      state.forcePersonalDataMessage = data;
    },
    forcePersonalDataErrorMessage(state, data) {
      state.forcePersonalDataErrorMessage = data;
    },
    setFaultDescription(state, data) {
      state.faultDescription = data;
    },
    setEmail(state, data) {
      state.email = data;
    },
    showSavedCardComponent(state, data) {
      state.showSavedCardComponent = data;
    },
    setAmount(state, data) {
      state.amount = data;
    },
    setLocale(state, data) {
      state.locale = data;
    },
    isDevMode(state, data) {
      state.isDevMode = data;
    },
    setLoginInfo(state, data) {
      state.loginInfo = data;
    },
    showAutoRechargeModal(state, data) {
      state.showAutoRechargeModal = data;
    },
    showDisableAutoRechargePrompt(state, data) {
      state.showDisableAutoRechargePrompt = data;
    },
    isUpdateReccuringAction(state, data) {
      state.isUpdateReccuringAction = data;
    },
    updateRecurringActionMsisdn(state, data) {
      state.updateRecurringActionMsisdn = data;
    },
    updateRecurringActionAmount(state, data) {
      state.updateRecurringActionAmount = data;
    },
    updateRecurringActionDate(state, data) {
      state.updateRecurringActionDate = data;
    },
    updateRecurringActionTransactionCode(state, data) {
      state.updateRecurringActionTransactionCode = data;
    },
    isDeleteReccuringAction(state, data) {
      state.isDeleteReccuringAction = data;
    },
    setErrorFromBank(state, data) {
      state.errorFromBank = data;
    },
  },
  strict: true,
});
